module.exports = __webpack_public_path__ + "img/thumb-008.9950b892.png";